// extracted by mini-css-extract-plugin
export var cases = "SuccessCases-module--cases--3orUq";
export var mainCases = "SuccessCases-module--mainCases--2lUNv";
export var slick = "SuccessCases-module--slick--5W623";
export var customDots = "SuccessCases-module--customDots--XqXtP";
export var caseBox = "SuccessCases-module--caseBox--2pjSL";
export var caseItem = "SuccessCases-module--caseItem--1wFxd";
export var title = "SuccessCases-module--title--3OzSe";
export var counter = "SuccessCases-module--counter--1gx7H";